import React from "react";
import { VMProvider } from "../../commons/base/providers/provider";
import MenuPreparationBomDashboardViewModel from "./view_models/menu_preparation_bom_view_model";
import Scaffold from "../../commons/scaffold/scaffold";
import MenuPreparationBomDashboardTableWidget from "./widgets/menu_preparation_bom_dashboard_table_widget";
import MenuPreparationBomDashboardReadOnlyFormWidget from "./widgets/menu_preparation_bom_dashboard_read_only_form_widget";
import MenuPreparationBomDashboardCreateWidget from "./widgets/menu_preparation_bom_dashboard_create_widget";
import MenuPreparationBomDashboardSearchWidget from "./widgets/menu_preparation_bom_dashboard_search_widget";
import SizedDiv from "../../commons/ui/sized_div";

export default class MenuPreparationBomDashboardScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider
                create={() => new MenuPreparationBomDashboardViewModel()}
            >
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isLoading}
                        loadingBackgroundType="semi_transparent"
                        showErrorView={vm.errorModel}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Menu Prep Bom Dashboard
                            </h1>

                            <MenuPreparationBomDashboardSearchWidget />

                            <SizedDiv height={12.0} />

                            <MenuPreparationBomDashboardTableWidget />

                            {vm.isReadOnlyFormOpen && (
                                <MenuPreparationBomDashboardReadOnlyFormWidget />
                            )}

                            {vm.isCreateFormOpen && (
                                <MenuPreparationBomDashboardCreateWidget />
                            )}

                            {/* Create New */}
                            <div className="fixed bottom-4 right-4">
                                <button
                                    className="px-4 py-4 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600"
                                    onClick={() => vm.openCreateForm()}
                                >
                                    Tambahkan Menu Prep BOM Baru
                                </button>
                            </div>
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
